import t from '@/i18n/translations'
import { CULTURE } from './helpers'
import type { IAccoItem } from './interfaces/apiInterfaces'

export function mapAccoItem(item: IAccoItem) {
  return {
    ...item,
    assessmentRating: item.assessmentRating.length === 1 && item.assessmentRating != '0' ? item.assessmentRating + ',0' : item.assessmentRating
  }
}

export function ratings(): Array<{ label: string; value: number }> {
  return [
    {
      label: t(`${CULTURE}.filter.rating.five`),
      value: 5
    },
    {
      label: t(`${CULTURE}.filter.rating.four`),
      value: 4
    },
    {
      label: t(`${CULTURE}.filter.rating.three`),
      value: 3
    },
    {
      label: t(`${CULTURE}.filter.rating.two`),
      value: 2
    },
    {
      label: t(`${CULTURE}.filter.rating.one`),
      value: 1
    }
  ]
}
